import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import Stepper from "containers/Contracts/components/Stepper";
import { CgSoftwareDownload } from "react-icons/cg";
import { toast } from "react-toastify";
import { Card, CardBody, Container } from "reactstrap";
import CSVImportSolicitationContract from "containers/Contracts/components/CSVImportSolicitationContract";
import { createBulkSolicitationContract } from "./actions";
import {
	RowContainer,
	Title,
	ContentContainer,
	MessageContainer,
	MessageTitle,
	MessageText,
	InstructionsContainer,
	InstructionsTitle,
	InstructionsItemList,
	InstructionsItem,
	ButtonsContainer,
	StepButton,
	Button
} from "./styles";
import dayjs from "dayjs";

const NewBulkContractSolicitation = () => {
	const history = useHistory();
	const dispatch = useDispatch();

	const [stage, setStage] = useState("start");
	const [csvData, setCsvData] = useState(null);
	const [validationErrors, setValidationErrors] = useState([]);
	const [selectedFile, setSelectedFile] = useState(null);
	const [selectedHirer, setSelectedHirer] = useState(null);

	const handleChangeStage = newStage => {
		setStage(newStage);
	};

	const handleCSVData = (data, errors, file, hirer) => {
		setCsvData(data);
		setValidationErrors(errors);
		setSelectedFile(file);
		setSelectedHirer(hirer);
	};

	const handleSubmitBulkSolicitation = () => {
		if (!selectedHirer || !csvData || validationErrors.length > 0) {
			toast.error("Por favor, corrija os erros antes de enviar.");
			return;
		}

		const validData = csvData.filter(row => row._isValid);

		if (validData.length === 0) {
			toast.error("Nenhum dado válido para processar.");
			return;
		}

		const requestData = validData.map(row => ({
			hirer: selectedHirer.value,
			hired: row.hired,
			contractType: row.contractType,
			role: row.role,
			contractReference: row.contractReference,
			activitiesDescription: row.activitiesDescription,
			modality: row.modality,
			value: parseInt(row.value),
			paymentDate: row.paymentDate,
			lifespan: parseInt(row.lifespan),
			startDate: dayjs(row.startDate, "DD/MM/YYYY"),
			priority: row.priority || undefined,
			tier: row.tier || undefined,
			additionalInformation: row.additionalInformation || ""
		}));

		dispatch(
			createBulkSolicitationContract(requestData, (err, result) => {
				if (err) {
					if (err.code) {
						toast.error("1" + err.code);
					} else if (typeof err === "string") alert("2" + err);
					else if (err.errors && err.errors.default)
						toast.error(err.errors.default);
					else toast.error(JSON.stringify("3" + err));
				} else if (result && result.message) {
					history.push(`/contracts/contract-solicitation-completed/`);
				}
			})
		);
	};

	return (
		<Container className="dashboard">
			<Card>
				<CardBody>
					<Stepper currentStep={2} />

					<RowContainer>
						<Title>Solicitação de Contratos em Massa</Title>
					</RowContainer>

					<ContentContainer>
						<MessageContainer>
							<MessageTitle>
								{stage === "start"
									? "Solicitar contratos em massa"
									: "Upload e validação da planilha"}
							</MessageTitle>
							<MessageText>
								{stage === "start"
									? "Baixe o modelo de planilha, preencha com todos os dados obrigatórios dos contratos e faça o upload."
									: "Selecione o contratante e faça o upload da planilha preenchida para validação dos dados."}
							</MessageText>
						</MessageContainer>

						{stage === "upload" && (
							<CSVImportSolicitationContract
								onCSVData={handleCSVData}
								onGoBack={() => handleChangeStage("start")}
								onSubmit={handleSubmitBulkSolicitation}
								validationErrors={validationErrors}
								selectedFile={selectedFile}
							/>
						)}

						{stage === "start" && (
							<>
								<InstructionsContainer>
									<InstructionsTitle>Instruções:</InstructionsTitle>
									<InstructionsItemList>
										<InstructionsItem>
											Baixe a planilha modelo clicando no botão abaixo
										</InstructionsItem>
										<InstructionsItem>
											Preencha todos os campos obrigatórios
										</InstructionsItem>
										<InstructionsItem>
											Não altere os cabeçalhos das colunas
										</InstructionsItem>
										<InstructionsItem>
											Salve o arquivo no formato XLSX
										</InstructionsItem>
									</InstructionsItemList>
								</InstructionsContainer>

								<ButtonsContainer>
									<a
										href="/xlsx/modelo-solicitacao-de-contratos-em-massa.xlsx"
										download
										style={{ textDecoration: "none" }}
									>
										<Button primary>
											<CgSoftwareDownload size={24} color="#ffffff" />
											<div>Baixar modelo da planilha</div>
										</Button>
									</a>
								</ButtonsContainer>
								<ButtonsContainer>
									<Link to="/contracts/contract-solicitation-selection">
										<StepButton>Voltar</StepButton>
									</Link>
									<StepButton
										primary
										onClick={() => {
											handleChangeStage("upload");
										}}
									>
										Avançar
									</StepButton>
								</ButtonsContainer>
							</>
						)}
					</ContentContainer>
				</CardBody>
			</Card>
		</Container>
	);
};

export default NewBulkContractSolicitation;
